import type { Category } from '../config';
import { RefProvider } from '../config';
import {
  initModalystStore,
  initZendropStore,
  initAutoDSStore,
  setupModalystProducts,
  setupZendropProducts,
  setupAutoDSProducts,
} from './endpoints';

export const initStoreByProvider: Record<RefProvider, (category: Category) => Promise<void>> = {
  [RefProvider.Standalone]: initModalystStore,
  [RefProvider.StoreBuilder]: initModalystStore,
  [RefProvider.ZenDrop]: initZendropStore,
  [RefProvider.AutoDS]: initAutoDSStore,
  [RefProvider.Batistella]: initModalystStore,
};

export const setupProductsByProvider: Record<RefProvider, (category: Category) => Promise<void>> = {
  [RefProvider.Standalone]: setupModalystProducts,
  [RefProvider.StoreBuilder]: setupModalystProducts,
  [RefProvider.ZenDrop]: setupZendropProducts,
  [RefProvider.AutoDS]: setupAutoDSProducts,
  [RefProvider.Batistella]: setupModalystProducts,
};
